<template>
  <main>
    <s-popover position="top" animation="slide-y" >
      <template #activator>
        <div class="topbar-usuario-activator" style="cursor: pointer;">
          <s-badge
            :label="user?.tipo?.nome"
            type="info"
          />
          <s-icon 
            icon="mdiAccountCircleOutline" 
            size="medium" 
            pointer
          />
        </div>
      </template>

      <template #content>
        <div class="topbar-usuario-content">
          <div class="topbar-usuario-container">
            <img 
              :src="avatarPath"
              alt="Avatar" 
              width="60"
              height="60"
              class="usuario-avatar"
            />

            <div class="topbar-usuario-text">
              <h3 class="topbar-usuario-name">
                {{ (user) ? user.nome : '' }}
              </h3>
              <p class="topbar-usuario-role">
                {{ (user && user.tipo) ? user.tipo.nome : '' }}
              </p>
              <p class="topbar-usuario-email" :title="user?.email">
                {{ (user) ? user.email : '' }}
              </p>
            </div>
          </div>
          
          <hr>

          <div class="topbar-usuario-actions">
            <s-button 
              variant="text" 
              color="text-secondary" 
              label="Alterar Senha"
              icon="mdiAccountEditOutline"
              @click="showModal()"
              class="topbar-usuario-button"
            />
            <s-button 
              variant="text" 
              color="text-secondary" 
              label="Sair"
              icon="mdiLogout"
              @click="logout"
              class="topbar-usuario-button"
            />
          </div>
        </div>
      </template>
    </s-popover>
  </main>
  <Teleport to="body">
    <AuthPasswordChange :id="currentId" v-model="modal" />
  </Teleport>
</template>

<script setup lang="ts">

import { SPopover, SIcon, SButton, SBadge } from '@sieg-ad/componentes-vue';
import { AuthPasswordChange } from '#components';
import { useAuthStore } from '~/stores/auth';

// COMPOSABLES

const authStore = useAuthStore();

// REFS

const currentId = ref<string | number | null>(null);
const modal = ref(false);

const { user } = storeToRefs(authStore);
// METHODS

const showModal = (id: string | number | null = null) => {
  modal.value = true;
  currentId.value = id;
};

const logout = () => authStore.logout();

const avatarPath = computed(() => resolveAssetUrl(user.value?.avatar?.icone));

</script>

<style scoped>
.topbar-usuario-activator {
  display: flex;
  align-items: center;
  color: #FFFFFF;
  font-size: 16px;
  padding: 0.5rem;
  gap: 0.5rem;
}
.topbar-usuario-activator:hover {
  background-color: rgba(255, 255, 255, 0.1);
  border-radius: 4px;
}

.topbar-usuario-content {
  width: 300px;
}

.topbar-usuario-container {
  display: flex;
  align-items: center;
  flex-direction: row;
  gap: 1rem;
}
.usuario-avatar {
  border-radius: 50%;
  -webkit-filter: drop-shadow(0 0 5px rgba(0, 0, 0, 0.3));
  filter: drop-shadow(0 0 5px rgba(0, 0, 0, 0.3));
}
.topbar-usuario-text {
  display: flex;
  flex-direction: column;
  color: #FFFFFF;
  /* sem isso o item flex nunca encolhe abaixo do conteúdo e o e-mail vaza do popover */
  min-width: 0;
}
.topbar-usuario-text > * {
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.topbar-usuario-name {
  font-size: 1.2rem;
}
.topbar-usuario-role,
.topbar-usuario-email {
  font-size: 0.9rem;
  color: var(--text-secondary);
}
.topbar-usuario-actions {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.5rem;
}

</style>